// import "./styles.css";
// import { Route, Routes } from "react-router-dom";
// import Navbar from "./components/Navbar";
// import Home from "./components/Home";
// import InternationalTourPackages from "./components/InternationalTours";
// import DomesticTourPackages from "./components/DomesticsTours";
// import Footer from "./components/Footer";
// import GroupTourPackages from "./components/GroupTours";
// import BlogPage from "./components/Blog";
// import DestinationPage from "./components/DestinationPage";
// import AdminDashboard from "./components/admin/dashboard";
// import CTA from "./components/CTA";
// import AdminLogin from "./components/admin/login";
// import PrivateRoute from "./components/PrivateRoute";
// import AgentConnect from "./components/AgentConnect";
// import { AuthProvider } from "./context/AuthContext";
// import Setting1 from "./components/agent/Setting";
// import Visa from "./components/Visa";
// import DeparturePage from "./components/agent/Departure";
// import HotelMarkup from "./components/agent/HotelMarkup";
// import AgentInternationalTourPackages from "./components/agent/InternationalTours";
// import AgentDomestics from "./components/agent/AgentDomestics";
// import AgentPackagesPage from "./components/agent/AgentPackages";
// import TermsAndConditions from "./components/otherinfo/termsandcondition";
// import PrivacyPolicy from "./components/otherinfo/PrivacyPolicy";
// // import Allpackage from "./components/allpackage";
// // import AllPackages from "./components/AllPackages";
// import Allpackage from "./components/allpackage";
// import EnquiryForm from "./components/EnquiryForm";


// export default function App() {
//   return (
  
//     <AuthProvider>
//       <Routes>
//         <Route path="/" element={<Home />} />
//         <Route path="/international-tours" element={<InternationalTourPackages />} />
//         <Route path="/domestic-tours" element={<DomesticTourPackages />} />
//         <Route path="/group-tours" element={<GroupTourPackages />} />
//         <Route path="/Blog" element={<BlogPage />} />
//         <Route path="/destination/:destinationName" element={<DestinationPage />} />
        
//         {/* Protected Admin Route */}
//         <Route path="/dashboard" element={
//           <PrivateRoute>
//             <AdminDashboard />
//           </PrivateRoute>
//         } />
        
//         <Route path="/CTA" element={<CTA />} />
//         <Route path="/Visa" element={<Visa />} />
//         {/* <Route path="/packages" element={<AllPackages />} /> */}
//         <Route path="/allpackage" element={<Allpackage/>}/>
//         <Route path="/EnquiryForm" element={<EnquiryForm />} />
//         <Route path="/login" element={<AdminLogin />} />
//         <Route path="/Agent-Connect" element={<AgentConnect />} />
        
//         {/* Protected Agent Routes */}
//         <Route path="/settings" element={ <Setting1 /> } />
//         <Route path="/departure" element={
//           <PrivateRoute>
//           <DeparturePage />
//           </PrivateRoute>
//         } />
//         <Route path="/hotelmarkup" element={<HotelMarkup />} />
//          {/* <Route path="/allpackage" element={<Allpackage />} /> */}
//         <Route path="/agent-international-tours" element={<AgentInternationalTourPackages />} />
//         <Route path="/agent-domestic-tours" element={<AgentDomestics />} />
//         <Route path="/agent-packages" element={<AgentPackagesPage />} />
//         <Route path="/AdminLogin" element={<AdminLogin />} />
//         <Route path="/termsandconditions" element={<TermsAndConditions/>}/>
//         <Route path="/privacypolicy" element={<PrivacyPolicy/>}/>
//       </Routes>
//     </AuthProvider>
//   );
// }





import "./styles.css";
import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import InternationalTourPackages from "./components/InternationalTours";
import DomesticTourPackages from "./components/DomesticsTours";
import Footer from "./components/Footer";
import GroupTourPackages from "./components/GroupTours";
import BlogPage from "./components/Blog";
import DestinationPage from "./components/DestinationPage";
import AdminDashboard from "./components/admin/dashboard";
import CTA from "./components/CTA";
import AdminLogin from "./components/admin/login";
import PrivateRoute from "./components/PrivateRoute";
import AgentConnect from "./components/AgentConnect";
import { AuthProvider } from "./context/AuthContext";
import Setting1 from "./components/agent/Setting";
import Visa from "./components/Visa";
import DeparturePage from "./components/agent/Departure";
import HotelMarkup from "./components/agent/HotelMarkup";
import AgentInternationalTourPackages from "./components/agent/InternationalTours";
import AgentDomestics from "./components/agent/AgentDomestics";
import AgentPackagesPage from "./components/agent/AgentPackages";
import TermsAndConditions from "./components/otherinfo/termsandcondition";
import PrivacyPolicy from "./components/otherinfo/PrivacyPolicy";
import Allpackage from "./components/allpackage";
import EnquiryForm from "./components/EnquiryForm";

// ✅ Import Helmet
import { Helmet } from "react-helmet";

export default function App() {
  return (
    <AuthProvider>
      {/* ✅ Global default SEO tags */}
      <Helmet>
        <title>Pearl Tours & Travels</title>
        <meta
          name="description"
          content="Pearl Tours & Travels offers international and domestic tour packages, group tours, visa assistance, and custom travel experiences."
        />
        <meta
          name="keywords"
          content="Pearl Tours & Travels Sangli, travel agency Sangli, tours and travels Sangli, Maharashtra travel agent, Sangli tour packages, Kolhapur tours, Pune to Goa packages, international tour packages India, domestic tour packages Maharashtra, group tours Maharashtra, visa assistance Sangli"
        />
        <meta name="author" content="Pearl Tours & Travels" />
        <link rel="canonical" href="https://pearltoursandtravel.in/" />

        {/* Organization & LocalBusiness JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pearl Tours & Travels",
            url: "https://pearltoursandtravel.in/",
            logo: "https://pearltoursandtravel.in/logo512.png"
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "TravelAgency",
            name: "Pearl Tours & Travels",
            url: "https://pearltoursandtravel.in/",
            image: "https://pearltoursandtravel.in/logo512.png",
            address: {
              "@type": "PostalAddress",
              addressLocality: "Sangli",
              addressRegion: "Maharashtra",
              addressCountry: "IN"
            },
            areaServed: ["Sangli", "Kolhapur", "Pune", "Maharashtra"],
            sameAs: []
          })}
        </script>
      </Helmet>

     

      <Routes>
        <Route path="/" element={
          <>
            <Helmet>
              <title>Home | Pearl Tours & Travels</title>
              <meta name="description" content="Plan your dream vacation with Pearl Tours & Travels. Explore our curated international and domestic tour packages." />
              <link rel="canonical" href="https://pearltoursandtravel.in/" />
            </Helmet>
            <Home />
          </>
        } />

        <Route path="/international-tours" element={
          <>
            <Helmet>
              <title>International Tours | Pearl Tours</title>
              <meta name="description" content="Explore our exclusive international tour packages to top destinations around the world." />
              <link rel="canonical" href="https://pearltoursandtravel.in/international-tours" />
            </Helmet>
            <InternationalTourPackages />
          </>
        } />

        <Route path="/domestic-tours" element={
          <>
            <Helmet>
              <title>Domestic Tours | Pearl Tours</title>
              <meta name="description" content="Discover beautiful destinations across India with our domestic tour packages." />
              <link rel="canonical" href="https://pearltoursandtravel.in/domestic-tours" />
            </Helmet>
            <DomesticTourPackages />
          </>
        } />

        <Route path="/group-tours" element={
          <>
            <Helmet>
              <title>Group Tours | Pearl Tours</title>
              <meta name="description" content="Enjoy affordable group tours with Pearl Tours & Travels, perfect for families, friends, and corporate trips." />
              <link rel="canonical" href="https://pearltoursandtravel.in/group-tours" />
            </Helmet>
            <GroupTourPackages />
          </>
        } />

        <Route path="/Blog" element={
          <>
            <Helmet>
              <title>Travel Blog | Pearl Tours</title>
              <meta name="description" content="Read our latest travel blogs, tips, and guides for your next adventure." />
              <link rel="canonical" href="https://pearltoursandtravel.in/Blog" />
            </Helmet>
            <BlogPage />
          </>
        } />

        <Route path="/destination/:destinationName" element={
          <>
            <Helmet>
              <title>Destination | Pearl Tours</title>
              <meta name="description" content="Get details about top destinations for your next trip with Pearl Tours & Travels." />
              <link rel="canonical" href="https://pearltoursandtravel.in/destination" />
            </Helmet>
            <DestinationPage />
          </>
        } />

        {/* Protected Admin Route */}
        <Route path="/dashboard" element={
          <PrivateRoute>
            <Helmet>
              <title>Admin Dashboard | Pearl Tours</title>
            </Helmet>
            <AdminDashboard />
          </PrivateRoute>
        } />

        <Route path="/CTA" element={<CTA />} />
        <Route path="/Visa" element={
          <>
            <Helmet>
              <title>Visa Assistance | Pearl Tours</title>
              <meta name="description" content="Pearl Tours helps you with visa assistance for your international trips." />
              <link rel="canonical" href="https://pearltoursandtravel.in/Visa" />
            </Helmet>
            <Visa />
          </>
        } />

        <Route path="/allpackage" element={
          <>
            <Helmet>
              <title>All Packages | Pearl Tours</title>
              <meta name="description" content="Browse all tour packages including international, domestic, and group tours." />
              <link rel="canonical" href="https://pearltoursandtravel.in/allpackage" />
            </Helmet>
            <Allpackage />
          </>
        } />

        <Route path="/EnquiryForm" element={<EnquiryForm />} />
        <Route path="/login" element={<AdminLogin />} />
        <Route path="/Agent-Connect" element={<AgentConnect />} />

        {/* Protected Agent Routes */}
        <Route path="/settings" element={<Setting1 />} />
        <Route path="/departure" element={
          <PrivateRoute>
            <DeparturePage />
          </PrivateRoute>
        } />
        <Route path="/hotelmarkup" element={<HotelMarkup />} />
        <Route path="/agent-international-tours" element={<AgentInternationalTourPackages />} />
        <Route path="/agent-domestic-tours" element={<AgentDomestics />} />
        <Route path="/agent-packages" element={<AgentPackagesPage />} />
        <Route path="/AdminLogin" element={<AdminLogin />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
      </Routes>

      <Footer />
    </AuthProvider>
  );
}


